import { IdTextPair } from "../../../models/id-text-pair";

export class ConstantValues {

  public static readonly parameterDownloadInteractionDays: IdTextPair[] = [
    { id: "1", text: 'Sunday' },
    { id: "2", text: 'Monday' },
    { id: "4", text: 'Tuesday' },
    { id: "8", text: 'Wednesday' },
    { id: "15", text: 'Thursday' }
  ];
  public static readonly terminalInteractionBankingWindowTimes: IdTextPair[] = [
    { id: "", text: "" },
    { id: "00:00 - 00:30", text: "00:00 - 00:30" },
    { id: "00:30 - 01:00", text: "00:30 - 01:00" },
    { id: "01:00 - 01:30", text: "01:00 - 01:30" },
    { id: "01:30 - 02:00", text: "01:30 - 02:00" },
    { id: "02:00 - 02:30", text: "02:00 - 02:30" },
    { id: "02:30 - 03:00", text: "02:30 - 03:00" },
    { id: "03:00 - 03:30", text: "03:00 - 03:30" },
    { id: "03:30 - 04:00", text: "03:30 - 04:00" },
    { id: "04:00 - 04:30", text: "04:00 - 04:30" },
    { id: "04:30 - 05:00", text: "04:30 - 05:00" },
    { id: "05:00 - 05:30", text: "05:00 - 05:30" },
    { id: "05:30 - 06:00", text: "05:30 - 06:00" },
    { id: "06:00 - 06:30", text: "06:00 - 06:30" },
    { id: "06:30 - 07:00", text: "06:30 - 07:00" },
    { id: "07:00 - 07:30", text: "07:00 - 07:30" },
    { id: "07:30 - 08:00", text: "07:30 - 08:00" },
    { id: "08:00 - 08:30", text: "08:00 - 08:30" },
    { id: "08:30 - 09:00", text: "08:30 - 09:00" },
    { id: "09:00 - 09:30", text: "09:00 - 09:30" },
    { id: "09:30 - 10:00", text: "09:30 - 10:00" },
    { id: "10:00 - 10:30", text: "10:00 - 10:30" },
    { id: "10:30 - 11:00", text: "10:30 - 11:00" },
    { id: "11:00 - 11:30", text: "11:00 - 11:30" },
    { id: "11:30 - 12:00", text: "11:30 - 12:00" },
    { id: "12:00 - 12:30", text: "12:00 - 12:30" },
    { id: "12:30 - 13:00", text: "12:30 - 13:00" },
    { id: "13:00 - 13:30", text: "13:00 - 13:30" },
    { id: "13:30 - 14:00", text: "13:30 - 14:00" },
    { id: "14:00 - 14:30", text: "14:00 - 14:30" },
    { id: "14:30 - 15:00", text: "14:30 - 15:00" },
    { id: "15:00 - 15:30", text: "15:00 - 15:30" },
    { id: "15:30 - 16:00", text: "15:30 - 16:00" },
    { id: "16:00 - 16:30", text: "16:00 - 16:30" },
    { id: "16:30 - 17:00", text: "16:30 - 17:00" },
    { id: "17:00 - 17:30", text: "17:00 - 17:30" },
    { id: "17:30 - 18:00", text: "17:30 - 18:00" },
    { id: "18:00 - 18:30", text: "18:00 - 18:30" },
    { id: "18:30 - 19:00", text: "18:30 - 19:00" },
    { id: "19:00 - 19:30", text: "19:00 - 19:30" },
    { id: "19:30 - 20:00", text: "19:30 - 20:00" },
    { id: "20:00 - 20:30", text: "20:00 - 20:30" },
    { id: "20:30 - 21:00", text: "20:30 - 21:00" },
    { id: "21:00 - 21:30", text: "21:00 - 21:30" },
    { id: "21:30 - 22:00", text: "21:30 - 22:00" },
    { id: "22:00 - 22:30", text: "22:00 - 22:30" },
    { id: "22:30 - 23:00", text: "22:30 - 23:00" },
    { id: "23:00 - 23:30", text: "23:00 - 23:30" }
  ];
  public static readonly terminalInteractionParameterTimes: IdTextPair[] = [
    { id: "23:00 - 23:30", text: "23:00 - 23:30" },
    { id: "23:30 - 00:00", text: "23:30 - 00:00" },
    { id: "00:00 - 00:30", text: "00:00 - 00:30" },
    { id: "00:30 - 01:00", text: "00:30 - 01:00" },
    { id: "01:00 - 01:30", text: "01:00 - 01:30" },
    { id: "01:30 - 02:00", text: "01:30 - 02:00" },
    { id: "02:00 - 02:30", text: "02:00 - 02:30" },
    { id: "02:30 - 03:00", text: "02:30 - 03:00" },
    { id: "03:00 - 03:30", text: "03:00 - 03:30" },
    { id: "03:30 - 04:00", text: "03:30 - 04:00" },
    { id: "04:00 - 04:30", text: "04:00 - 04:30" },
    { id: "04:30 - 05:00", text: "04:30 - 05:00" },
    { id: "05:00 - 05:30", text: "05:00 - 05:30" },
    { id: "05:30 - 06:00", text: "05:30 - 06:00" },
    { id: "06:00 - 06:30", text: "06:00 - 06:30" },
    { id: "06:30 - 07:00", text: "06:30 - 07:00" },
    { id: "07:00 - 07:30", text: "07:00 - 07:30" }
  ];

  public static readonly governmentalOptions: IdTextPair[] = [
    { id: "Yes", text: 'Yes' },
    { id: "No", text: 'No' }
  ];
  public static readonly terminalDeliveryMethod: IdTextPair[] = [
    { id: "Courier", text: 'Courier' },
    { id: "Collection", text: 'Collection' },
    { id: "Field Services", text: 'Field Services' }
  ];

  public static readonly hidenControls = ['subMerchantId', 'independentSalesOrgId', 'paymentFacilitatorId', 'paymentFacilitatorIdVisa', 'merchantVerificationValue',
  'customerServicePhoneNo', 'merchantStreetAddress', 'independentSalesOrgIdVisa'];

  public ngOnInit(): void {  
  }
}
